type ToastPosition = "top" | "middle" | "bottom";
import { toastController } from "@ionic/vue";

/**
 * @param msg - 提示信息
 * @param position - 提示在视口位置 'top' | 'middle' | 'bottom'
 * @param duration - 提示停留时间
 * */
export async function openMsgToast(msg: string, position?: ToastPosition, duration?: number) {
  const toast = await toastController.create({
    message: msg,
    duration: duration || 1000,
    position: position || "middle",
    cssClass: "common_toast_controller_class",
  });
  await toast.present();
}
export function checkUserType(): boolean {
  const userinfo = JSON.parse(localStorage.getItem("userinfo") as string) || {}
  if (userinfo.userType === 1) {
    openMsgToast("没有权限操作")
    return true
  }
  return false
}
